import httpClient from './httpClient';
import { getApiBaseUrl } from '../data/authStorage';

const root = () => `${getApiBaseUrl()}/organizations/learning-management`;
export const listLearningCourses = async () => (await httpClient.get(`${root()}/courses`)).data;
export const createLearningCourse = async (course) => (await httpClient.post(`${root()}/courses`, course)).data;
export const enrollInLearningCourse = async (id) => (await httpClient.post(`${root()}/courses/${encodeURIComponent(id)}/enroll`)).data;
export const updateLearningProgress = async (id, progress) => (await httpClient.patch(`${root()}/courses/${encodeURIComponent(id)}/progress`, { progress })).data;
